export default "__VITE_ASSET__pFKihY8p__"